import RequirementGathering from "../../../../assets/images/Devprocess/RequirementGathering.svg";
import Design from "../../../../assets/images/Devprocess/Design.svg";
import Prototype from "../../../../assets/images/Devprocess/Prototype.svg";
import Development from "../../../../assets/images/Devprocess/Development.svg";
import QualityAssurance from "../../../../assets/images/Devprocess/QualityAssurance.svg";
import Deployment from "../../../../assets/images/Devprocess/Deployment.svg";
import Support from "../../../../assets/images/Devprocess/Support.svg";

export default [
  {
    image: RequirementGathering,
    name: "Requirement Gathering",
    description:
      "Thoroughly understanding client needs, we meticulously gather project requirements, laying the foundation for successful development.",
  },
  {
    image: Design,
    name: "Design",
    description:
      "Our designers create visually captivating and functionally intuitive interfaces, emphasizing user experience and aesthetic appeal.",
  },
  {
    image: Prototype,
    name: "Prototype",
    description:
      "Our designers create visually captivating and functionally intuitive interfaces, emphasizing user experience and aesthetic appeal.",
  },
  {
    image: Development,
    name: "Development",
    description:
      "Skilled developers bring concepts to life, leveraging cutting-edge technologies to create robust and scalable solutions with best practices of code.",
  },
  {
    image: QualityAssurance,
    name: "Quality Assurance",
    description:
      "Dedicated QA teams rigorously test every aspect, ensuring high performance, security, and seamless user experience and best quality product.",
  },
  {
    image: Deployment,
    name: "Deployment",
    description:
      "We ensure smooth transitions from development to live environments, minimizing downtime and disruptions during deployment.",
  },
  {
    image: Support,
    name: "Support & Maintenance",
    description:
      "Our commitment extends beyond deployment, providing ongoing support and maintenance services for continuous optimization.",
  },
];
